module.exports = __webpack_public_path__ + "assets/icons/hourglass.gif";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/hourglass.gif
// module id = ./src/styles/icons/emojies/hourglass.gif
// module chunks = 0